// src/api/users.ts
import api from './index'
import type { ApiResponse } from './index'

// ✅ Интерфейсы
export interface UserItem {
  id: number
  name: string
  login: string
  mail: string
  codeConfirm: string
  isConfirm: boolean
  isActivate: boolean
  role: {
    id: number
    code: string
    name: string
  } | null
}

export interface UserUpdateRequest {
  id: number
  name: string
  login: string
  mail: string
  codeConfirm: string
  isConfirm: boolean
  isActivate: boolean
  roleId: number
}

export interface UserCreateRequest {
  name: string
  login: string
  mail: string
  codeConfirm: string
  isConfirm: boolean
  isActivate: boolean
  roleId: number
}

export interface ChangePasswordRequest {
  id: number
  password: string
  confirm: string
}

export interface UserProfileResponse {
  id: string
  name: string
  email: string
  role: string
}

// ✅ Методы API пользователей
export const usersApi = {
  // Получение списка пользователей
  getAll(): Promise<ApiResponse<UserItem[]>> {
    return api.get<UserItem[]>('/api/user/getAll')
  },

  // Получение пользователя по ID
  getById(id: number): Promise<ApiResponse<UserItem>> {
    return api.get<UserItem>(`/api/user/getById?id=${id}`)
  },

  // Создание пользователя
  create(data: UserCreateRequest): Promise<ApiResponse> {
    return api.post('/api/user', data)
  },

  // Обновление пользователя
  update(data: UserUpdateRequest): Promise<ApiResponse> {
    return api.put('/api/user', data)
  },

  // Удаление пользователя
  delete(userId: number): Promise<ApiResponse> {
    return api.delete(`/api/user?user_id=${userId}`)
  },

  // Смена пароля
  changePassword(data: ChangePasswordRequest): Promise<ApiResponse> {
    return api.put('/api/user/change-password', data)
  },

  // Получение профиля текущего пользователя
  getProfile(): Promise<ApiResponse<UserProfileResponse>> {
    return api.get<UserProfileResponse>('/api/user')
  },

  // Обновление профиля
  updateProfile(name: string, email: string): Promise<ApiResponse> {
    return api.put('/api/user/profile', { name, email })
  },

  // Удаление аккаунта
  deleteAccount(): Promise<ApiResponse> {
    return api.delete('/api/user/account')
  }
}

export default usersApi